import { render, staticRenderFns } from "./CustomerDetails_mobile.vue?vue&type=template&id=74ad84a2&scoped=true"
import script from "./CustomerDetails_mobile.vue?vue&type=script&lang=js"
export * from "./CustomerDetails_mobile.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetails_mobile.vue?vue&type=style&index=0&id=74ad84a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ad84a2",
  null
  
)

export default component.exports